import axios from 'axios';
import useAuthStore from '@store/useAuthStore';

const API_URL = import.meta.env.VITE_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add auth token
api.interceptors.request.use(
  (config) => {
    const token = useAuthStore.getState().token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response, config } = error;

    if (response) {
      // Handle 401 - Unauthorized (but not for login endpoint)
      if (response.status === 401 && !config.url?.includes('/auth/login')) {
        useAuthStore.getState().logout();
      }

      // Handle other errors
      const message = response.data?.message || 'Ha ocurrido un error';
      error.message = message;
    } else {
      error.message = 'Error de conexión con el servidor';
    }

    return Promise.reject(error);
  }
);

export default api;

// API helper functions
export const apiGet = (url, config = {}) => api.get(url, config);
export const apiPost = (url, data, config = {}) => api.post(url, data, config);
export const apiPut = (url, data, config = {}) => api.put(url, data, config);
export const apiPatch = (url, data, config = {}) => api.patch(url, data, config);
export const apiDelete = (url, config = {}) => api.delete(url, config);
